import { IBorrowerVariableConfiguration } from 'api/digifi/los/layout/VariableConfigurationsApi';
import { LayoutConfigurationEntityName } from 'enums/LayoutConfigurationEntityName';
import { LayoutConfigurationReferenceType } from 'product_modules/enums/LayoutConfigurationReferenceType';

import { createLayoutEntitiesSlice } from './createLayoutEntitiesSlice';

const {
  reducer,
  removeLayoutEntities: removeBorrowerProfileVariables,
} = createLayoutEntitiesSlice<
  IBorrowerVariableConfiguration
>({
  referenceType: LayoutConfigurationReferenceType.BorrowerProfile,
  layoutConfigurationEntityName: LayoutConfigurationEntityName.Variable,
});

export {
  removeBorrowerProfileVariables,
};

export default reducer;
